import { getSectionForItem } from '../selectors/getEntriesBySection';
import { getMostUrgentState } from 'owa-copilot-async-chat-utils/lib/utils/getMostUrgentState';
import type { SurfacedAsyncItem } from 'owa-copilot-async-chat-utils/lib/selectors/getSurfacedAsyncItems';
import { TasksHubSection } from './TasksHubSection';

export interface TasksHubBacklog {
    total: number;
    needsYourInputCount: number;
    inProgressCount: number;
    mostUrgentState: string;
}

/** Summarizes the given Tasks Hub items for telemetry, split by section. */
export function getTasksHubBacklog(items: SurfacedAsyncItem[]): TasksHubBacklog {
    const inProgressCount = items.filter(
        item => getSectionForItem(item) === TasksHubSection.InProgress
    ).length;

    return {
        total: items.length,
        needsYourInputCount: items.length - inProgressCount,
        inProgressCount,
        mostUrgentState: getMostUrgentState(items) ?? 'none',
    };
}
